const authHu = {
    "sign_in": "Bejelentkezés",
    "email": "Email cím",
    "password": "Jelszó",
    "sign_in_button": "Belépés",
    "invalid_credentials": "Hibás belépési adatok",
    "password_min_length": "A jelszónak legalább 8 karakter hosszúnak kell lennie",
    "passwords_do_not_match": "A jelszavak nem egyeznek",
    "invalid_token": "Érvénytelen token",
    "password_set": "Jelszó beállítva",
    "confirm_password": "Jelszó megerősítése",
    "confirm_title": "Quickpick Admin Regisztráció megerősítése",
    "confirm_text": "A fiók beállításához már csak egy biztonságos jelszó megadására van szükség",
    "set_password": "Jelszó beállítása",
    "account_activated": "Fiók aktiválva",
    "account_activated_text": "Mostantól be tudsz jelentkezni a felhasználói fiókodba a megadott email címeddel és jelszavaddal.",
    "continue_to_login": "Tovább a bejelentkezéshez",
    "forgotten_password": "Elfelejtettem a jelszavam",
    "unable_to_reset_password": "Szerver oldali hiba. Jelszóvisszaállítás sikertelen.",
    "reset_password_title": "Jelszó visszaállítása",
    "reset_password_text": "Kérjük, adja meg az email címét, amellyel regisztrálva lett a rendszerbe. Az email címre elküldjük a jelszó visszaállításához szükséges linket.",
    "send_reset_mail": "Jelszó visszaállító link küldése",
    "send_reset_mail_success": "Az email címre elküldtük a jelszó visszaállításához szükséges linket",
    "invalid_email": "Érvénytelen email cím",
    "reset_sent": "Üzenet elküldve",
    "change_password_title": "Jelszó megváltoztatása",
    "change_password_success": "Jelszó sikeresen megváltoztatva",
    "roles": {
        "OWNER": "Admin",
        "MENU_EDITOR": "Menü szerkesztés",
        "STAFF_MANAGER": "Személyzet szerkesztés"
    },
    "name": "Név",
    "permissions": "Jogosultságok",
    "create_user_permissions": "Jogosultságok létrehozása",
    "add_restaurant": "Étterem hozzáadása",
    "user_saved": "Felhasználó mentve",
    "has_admin_permissions": "Admin jogosultságok",
    "login_with_google": "Bejelentkezés Google fiókkal",
    "missing_perrmissions": "Nincsenek meg a szükséges jogosultságok a hozzáféréshez",
    "qp_signup_title": "QuickPick Regisztráció",
    "qp_signup_text": "Töltsd ki az alábbi mezőket, és hozz létre egy felhasználói fiókot!",
    "user_information": "Felhasználói információk",
    "restaurant_information": "Étterem információk",
    "restaurant_shortname": "Étterem azonosító",
    "restaurant_name": "Étterem neve",
    "create_profile": "Létrehozás",
    "restaurant_name_short": "Az étterem nevének legalább 3 karakter hosszúnak kell lennie",
    "identifier_example": "Példa azonosító",
    "invalid_shortname": "Étterem azonosító legalább 3 karakter hosszúnak kell lennie",
    "restaurant_shortname_already_in_use": "Az étterem azonosító már használatban van",
    "name_missing": "Név nincsen megadva",
    "signup_failed": "Regisztráció sikertelen. Kérjük próbálkozz meg később.",
    "no_restaurant_title": "Nincs étterem kiválasztva a fiókodhoz",
    "no_restaurant_text": "Ha éppen most hoztad létre a fiókodat, akkor érdemes regisztrálnod az éttermedet is!",
    "no_restaurant_alt": "Ha hozzáférést kellett volna kapnod egy étteremhez, kérjük vedd fel a kapcsolatot az étterem fiókjának kezelőjével.",
    "no_user_created_yet": "Még nincs fiókod?",
    "signup_success": "Regisztráció sikeres",
    "grant_admin_title": "Admin jogosultságok megadása",
    "grant_admin_confirmation": "Az admin jogosultságokkal rendelkező felhasználó kezelheti az étterem beállításait, felhasználókat adhat hozzá és távolíthat el, valamint kezelheti az előfizetéseket és számlákat. A menü szerkesztéséhez nem szükséges admin jogosultság.",
    "selected_user": "Kiválasztott felhasználó",
    "delete_user_title": "Felhasználó eltávolítása",
    "delete_user_confirmation": "A kiválasztott felhasználó eltávolításra kerül az étteremből, és nem lesz hozzáférése a menühöz. Ez a művelet nem vonható vissza.",
    "admin": "Admin",
    "activate_account": "Fiók aktiválása",
    "account_pending_activation": "A felhasználói fiókod aktiválásra vár.",
    "check_your_activate_email": "Kérjük, ellenőrizd az email fiókod, és kattints az aktiváló linkre",
    "refresh_page": "Oldal újratöltése",
    "did_not_receive_activation_email": "Nem kaptam aktiváló emailt",
    "activate_tip": "Ha nem találod az aktiváló emailt, ellenőrizd a spam mappát is. Ha ott sincs, kattints az alábbi gombra az email újraküldéséhez.",
    "resend_email": "Újraküldés",
    "email_resent": "Az aktiváló emailt sikeresen újraküldtük. Kérjük, ellenőrizd az email fiókodat.",
    "accept_terms_and_conditions": "Elolvastam és elfogadom az <a>Általános Szerződési Feltételeket és az Adatvédelmi Szabályzatot</a>",
    "complete_registration": "Regisztráció befejezése",
    "auth_in_progress": "Hitelesítés folyamatban...",
    "account_successfully_activated": "A QuickPick fiókod sikeresen aktiválva lett",
    "continue_to_home_page": "Tovább a főoldalra",
    "invalid_activation": "Hiba történt a fiók aktiválása során. Kérjük, próbáld meg újra később, vagy lépj kapcsolatba az ügyfélszolgálatunkkal.",
    "activation_mail_sent": "Elkezdtük a fiókod létrehozását. Kérjük, ellenőrizd az email fiókodat és véglegesítsd a regisztráciiót a levélben kapott linkre kattintva."
}

export default authHu;